import Image from './src/image.mjs';
export { imageEmits, imageProps } from './src/image2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElImage = withInstall(Image);

export { ElImage, ElImage as default };
//# sourceMappingURL=index.mjs.map
